export var DropTargetType = {
  NONE: 'none',
  ROW: 'row',
  COLUMN: 'column'
};